/**
 * 给当前页所有的a标签添加自定义参数
 */
import { addQueryToUrl } from 'src/frontend-lib/tools/utils'

export const addPageLinkQuery = (obj = {}) => {
  try {
    $('a').each(function() {
      var aHref = $(this).attr('href')
      if (aHref && aHref.startsWith('http')) {
        aHref = aHref.endsWith('&') ? aHref.slice(0, aHref.length - 1) : aHref
        $(this).attr(
          'href',
          addQueryToUrl(aHref, {
            ...obj
          })
        )
      }
    })
  } catch (error) {
    console.log(error)
  }
}



// WEBPACK FOOTER //
// ./src/public-resource/libs/utils/addPageLinkQuery.js